import React from 'react';

const EulaModal = ({ isOpen, onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal show" onClick={handleOverlayClick}>
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h2 className="eula-title" style={{ color: '#fff' }}>End User License Agreement</h2>
        <div className="eula-text">
          <p>By accessing and using OSIRIS, you agree to:</p>
          <ul>
            <li>Use the platform only for legitimate security research and threat intelligence purposes</li>
            <li>Comply with all applicable laws and regulations</li>
            <li>Respect privacy and data protection requirements</li>
            <li>Not use the platform for malicious purposes or unauthorized access</li>
            <li>Maintain confidentiality of any sensitive information obtained</li>
            <li>Report any security vulnerabilities or concerns immediately</li>
          </ul>
          <p>The platform is provided "as is" without warranty of any kind. We reserve the right to terminate access for any violation of these terms.</p>
        </div>
      </div>
    </div>
  );
};

export default EulaModal; 